import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { DD_MMMM_YYYY } from 'constants/date';

export const getTableDate = (tableInfoDate) => {
  try {
    return tableInfoDate
    ? format(new Date(tableInfoDate.replace(' ', 'T')), DD_MMMM_YYYY, { locale: es })
      : '';
  } catch (error) {
    return '';
  }
};
